//import cookie from "../../store/modules/cookies"
export default function guest({next, store }) {
  //console.log("some user in here")

  //console.log(cookie.get("token"))
  /* if (cookie.get("token")) {
    //console.log("We have found a token", cookie.get("token"));
    store.dispatch("userauth/aTokenLogin", cookie.get("token"))
  } */
  if (store.getters["userauth/gLoggedIn"]) {
    next({name: "Profile_home"});
  }
  return next();
}
